import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { APIConfigMapping, APP_BUILDER_PERMISSIONS, HTTPAPIConfig, PERMISSIONS_ACTIONS, VlDataService, VlHttpService } from 'shared-library';
import { ActivatedRoute, Params } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../Services/shared.service';
import { WORKFLOW_EVENT_TYPES } from '../../constants/proj.cnst';
import { Subject, take, takeUntil } from 'rxjs';
import { PAGEI, PAGE_CONFIGI } from '../../models/page_config_json';
import { PageRearrangeService } from '../mobi-pages/services/page-rearrange.service';


export interface Entity {
  application_id: string;
  child_entity_ids_list: ChildEntity;
  entity_id: string;
  entity_name: string;
  open?: boolean;
}

export interface ChildEntity {
  [key: string] : {
    child?: any,
    parent?: any
  }
}

export interface EntityDetails {
  widgetId: string;
  widgetLabel: string;
}

export interface PageDetails {
  pageId: string;
  pageName: string;
  pageType: string;
  entityId?: string;
}

export interface WorkFlow {
  entity_id: string;
  worflow_id: string;
  workflow_name: string;
  open?: boolean;
}

export interface Stage {
  workflow_id: string;
  stage_id: string;
  stage_name: string;
}

@Component({
  selector: 'lib-entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.scss']
})
export class EntityComponent implements OnInit,OnDestroy {

  @ViewChild("addWorkFlowPopUp") workFlowtemplate!: TemplateRef<any>;
  queryParams: {
    [key: string]: string;
  } = {};
 
  pageList: PageDetails[] = [];
  pageListDropdown: PageDetails[] = [];
  entityList: Entity[] = [];
  relatedEntityList: Entity[] = [];
  workflowEntityList: WorkFlow[] = [];
  reversedWorkflowList: WorkFlow[] = [];
  stageWorkFlowList: Stage[] = [];
  entityDetails: any;
  isAddEntity: boolean = false;
  isAddAttributes: boolean = true;
  isAddRelations: boolean = true;
  entityForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    attributes: new FormControl(null),
    child: new FormControl(null),
    childField: new FormGroup({
      parent: new FormControl(null),
      child: new FormControl(null)
    })
  })
  pagesAdded: PageDetails[] = [];
  entityPages: PageDetails[] = [];
  removedPages: string[] = [];
  relativeEntityAdded: Entity[] = [];
  relativeEntity: Entity[] = [];
  removedRelativeEntity: string[] = [];
  showRelativeField: boolean = false;
  entityFields: EntityDetails[] = [];
  selectedEntityFields: EntityDetails[] = [];
  relativeEntityForPostData: any = {};
  isEntityNameEdit: {
    [key: string]: boolean
  } = {};
  isEdit: boolean = false;
  popupEntity!: { entityId: string | null; entityName: string | null; };
  newEntityId!: string;
  isEntityNameUnique: boolean=true;
  childFieldClicked :boolean=false;
  parentFieldClicked:boolean=false;
  showselectEntityParentError:boolean = false;
  showselectEntityChildError:boolean = false;
  deleteEntityid!:string;
  showselectPageError:boolean = false;
  selectedEntityName: string ='';
  matPanelStatus: boolean = false;
  relatedPanelStatus: boolean = false;
  workflowPanelStatus: boolean = false;
  stagePanelStatus: boolean = false;
  buttonClickedChild: boolean = false;
  buttonClickedParent: boolean =false;
  entityName!: string;
  pageNamesList: string[] = [];
  isSelectFocused: boolean =false;
  entityDetailsList: any;
  isLoadingMappedEntities:boolean = false;
  eventTypes = WORKFLOW_EVENT_TYPES;

  workFlowForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    stages: new FormArray([])
  });
  editWorkFlowId!: string;
  selectedEntity!: string | null;
  workFlowDeleteEntity!: { deleteId: string; deleteName: string; entityId: string; };
  selectedWorkflowIndex:number = 0;
  selectedStageId!:string;
  stageSpinner:boolean = false;
  destroy$:Subject<void> = new Subject<void>();
   appPermissions = APP_BUILDER_PERMISSIONS;
    permissionsActions = PERMISSIONS_ACTIONS;
  constructor(
    private toastrService: ToastrService,
    private sharedService:SharedService,
    private httpService: VlHttpService,
    private dataService: VlDataService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private pageRearrangeService:PageRearrangeService
  ) {}

  ngOnInit(): void {
    this.subscribeRouterEvents();
    this.subscribeFormEvents();
    this.subscribeWorkFlowEvents();
    this.subscribePanelEvents();
    this.initMethods();
    this.subscribeToPages();
  }

  /**
   * calling the below method to subscribe the events for device profile update status
   */

  subscribeRouterEvents(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams[param] = params[param];
        }
      }
    });
  }

  subscribeFormEvents() {
    this.entityForm.get('attributes')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      if (value) {
        const page = this.pageList.find((ele: PageDetails) => ele.pageId == value);
        if (page) {
          this.entityPages.push(page);
          this.updatePageListDropdown(); // Centralized filtering
          this.isAddAttributes = false;
          this.showselectPageError = false;
        }
      }
    });
    this.relatedEntityList = this.entityList?.filter(
      (entity) => !this.relativeEntity?.some((entityPage) => entityPage?.entity_id === entity?.entity_id)
    );
    this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
  }

  subscribeWorkFlowEvents() {
    this.sharedService.workflowSubject$.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response.status) {
        this.fetchWorkFlows(response.entity);
      }
    })
  }
  
  subscribePanelEvents(){
    this.sharedService.sidenavContentlistSubject$.pipe(takeUntil(this.destroy$)).subscribe((option) => {
      if(!option.isActive){
        this.selectedStageId = '';
      }
    })
  }
  private subscribeToPages(): void {
    this.sharedService.pages1$.pipe(takeUntil(this.destroy$)).subscribe((pages: PAGEI[]) => {
     const order = this.sharedService.getApplicationDataEntire()['page_ids_list']
     if(order){
       pages = this.pageRearrangeService.rearrangePages(pages,order);
     }
      this.pageList = pages
        .filter((page: PAGEI) => page.pageId !== undefined) // Ensure pageId exists
        .map((page: PAGEI) => ({
          pageId: page.pageId!, // Non-null assertion since we filtered undefined
          pageName: page.pageName,
          pageType: page.pageType ?? '', // Default to empty string if undefined
          entityId: (page as any).entity_id ?? '', // Add entityId if needed, default to empty string
        }))
        .filter(
          (value: PageDetails) => !['Splash Screen', 'Login', 'Preview'].includes(value.pageName) &&
                                  !['dataListView', 'PreviewPage'].includes(value.pageType)
        );
      this.updatePageListDropdown(); // Update dropdown whenever page list changes
    });
  
    
    if (!this.sharedService.getPages().length) {
      this.sharedService.getAllPages();
    }
  }
  private subscribeToPagesWithEntityMap(pageToEntityMap: { [pageId: string]: string }) {
    this.sharedService.pages1$.pipe(takeUntil(this.destroy$)).subscribe((pages: PAGEI[]) => {
      const order = this.sharedService.getApplicationDataEntire()['page_ids_list']
      if(order){
        pages = this.pageRearrangeService.rearrangePages(pages,order);
      }
      this.pageList = pages
        .filter((page: PAGEI) => page.pageId !== undefined)
        .map((page: PAGEI) => ({
          pageId: page.pageId!,
          pageName: page.pageName,
          pageType: page.pageType ?? '',
          entityId: pageToEntityMap[page.pageId!] ?? '', // Use map to set entityId
        }))
        .filter(
          (value: PageDetails) =>
            !['Splash Screen', 'Login', 'Preview'].includes(value.pageName) &&
            !['dataListView', 'PreviewPage'].includes(value.pageType)
        );
      this.updatePageListDropdown();
    });
  
    if (!this.sharedService.getPages().length) {
      this.sharedService.getAllPages();
    }
  }

  isEntityUnique(newLabel: string): boolean {
    return !this.entityList.some(item => item.entity_name.toLowerCase().trim() === newLabel.toLowerCase().trim());
  }
  onEnterPressed(entityId :any){
    if(!this.entityForm.invalid && this.isEntityNameUnique === true){
      this.saveEntiy(entityId);
    }
  }

  onEntityNameAdd(event :any){
    
    if(!this.isEntityUnique(event.target.value)){
      this.isEntityNameUnique = false;
    } else{
      this.isEntityNameUnique = true;
    }
    
    const addEntityName: any = this.entityForm.value.name.trimLeft();
    this.entityForm.get('name')?.setValue(addEntityName);
  }

  editEntityName(template:TemplateRef<any>, entityId: string, entityName: string) {
    this.isEntityNameEdit[entityId] = true;
    this.entityForm.get('name')?.setValue(entityName);
    this.openModal(template, true, entityId, entityName);
    this.entityForm.patchValue({
      name:entityName
    })
  }

  openWorkFlowModal(template:TemplateRef<any>, isEdit: boolean, entityId: string | null = null, entityName: string | null = null): void {
    this.workFlowForm.reset();
    this.stageArray.clear();
    this.stageArray.push(this.addStageGroup());
    this.stageArray.push(this.addStageGroup());
    this.openModal(template, isEdit, entityId, entityName)
  }

  openModal(template:TemplateRef<any>, isEdit: boolean, entityId: string | null = null, entityName: string | null = null): void {
    this.isEntityNameUnique = true;
    this.entityForm.reset();
    this.dialog.open(template, {
      disableClose: true,
      restoreFocus:false
    });
    this.isEdit = isEdit;
    this.popupEntity = {
      entityId,
      entityName
    }
  }

  openWorkFlowDeleteModal(template:TemplateRef<any>, deleteId: string, deleteName: string, entityId: string): void {
    this.isEntityNameUnique = true;
    this.entityForm.reset();
    this.dialog.open(template, {
      disableClose: true,
      restoreFocus:false
    });
    this.workFlowDeleteEntity = { deleteId, deleteName, entityId };
  }

  closeTemplate(): void {
    this.dialog.closeAll();
  }

  async refreshPageToEntityMap() {
    this.entityList = await this.fetchEntity();

    // Build page-to-entity map directly from the initial entity list
    const pageToEntityMap: { [pageId: string]: string } = {};
    for (const entity of this.entityList) {
      const pageIds = (entity as any).page_ids_list ?? [];
      pageIds.forEach((pageId: string) => {
        pageToEntityMap[pageId] = entity.entity_id;
      });
    }
    this.subscribeToPagesWithEntityMap(pageToEntityMap);
  }
  
  saveEntiy(entityId: string | null = null) {
    this.selectedEntityName = this.entityForm.get('name')?.value;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPDATE_ENTITY']);
    apiConfig.postData = {
      entity_id: entityId,
      entity_name: this.entityForm.get('name')?.value.trim(),
      child_entity_ids_relation: null,
      application_id: this.queryParams['id'],
      page_ids_list: null,
      removal_page_ids_list: null,
      removal_child_entity_ids_relation: null
    }

    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        this.newEntityId = response.entity_id;
        this.toastrService.success(response.message);        
      },
      complete: async () => {
        this.closeTemplate();
        this.entityPages = [];
        const newEntity: Entity = {
          application_id: this.queryParams['id'],
          child_entity_ids_list: {},
          entity_id: this.newEntityId,
          entity_name: this.entityForm.get('name')?.value.trim(),
          open: true
        };
        if (entityId) {
          // Update existing entity
          this.entityList = this.entityList.map(entity =>
            entity.entity_id === entityId ? { ...entity, entity_name: newEntity.entity_name } : entity
          );
        } else {
          // Add new entity
          this.entityList.push(newEntity);
          this.entityList = this.entityList.map((value, index) => ({
            ...value,
            open: value.entity_id === this.newEntityId
          }));
        }
        if (!entityId || this.entityDetails?.entity_id === entityId) {
          this.entityDetails = {
            entity_id: this.newEntityId,
            entity_name: newEntity.entity_name,
            page_ids: [],
            entity_relation: []
          };
        }
        this.updatePageListDropdown();
        this.entityDetails = await this.fetchEntity(this.newEntityId);
        this.entityList.map((value: Entity, index: number) => { value.open = value.entity_id == this.newEntityId;});
      },
      error: () => {}
    })
  }

  addPage() {
    this.isAddAttributes = true;
    this.entityForm.get('attributes')?.value ? this.showselectPageError = false : this.showselectPageError = true; 
    this.entityForm.get('attributes')?.reset();
    this.updatePageListDropdown();
    
  }
  
  removePageFromEntity(pageId: string, index: number) {
    this.removedPages.push(pageId);
    const entityPages = this.entityPages.splice(index, 1)[0];
    this.pageListDropdown.push(entityPages);  
    this.pageListDropdown.sort((a, b) => a.pageName.localeCompare(b.pageName));
  }

  togglePanelRelatedEntity(entity : boolean){
    this.parentFieldClicked=false;
    this.childFieldClicked=false;
    this.showselectEntityParentError=false;
    this.showselectEntityChildError=false;
    this.relatedPanelStatus = entity;
  }

  addRelatedEntities() {
    this.isAddRelations = true;
    const relativeEntity = this.entityForm.get('child')?.value;    
    if(relativeEntity) {
      const entity = this.entityList.find((ele: Entity) => ele.entity_id == relativeEntity);
      const childFieldsData = this.entityForm.get('childField')?.value;
      this.buttonClickedChild = true; 
      this.buttonClickedParent =true;
      this.showselectEntityParentError = childFieldsData.parent ? false : true;
      this.showselectEntityChildError = childFieldsData.child ? false : true;
      if(!Object.values(childFieldsData).every(value => value !== null && value !== undefined)) {
        return;
      }
      this.removedRelativeEntity = this.removedRelativeEntity.filter((id:any) => id!=relativeEntity);
      if(entity) {
        this.relativeEntity.push(entity);
        this.relativeEntityForPostData[relativeEntity] = this.entityForm.get('childField')?.value;
      }
      
      this.entityForm.get('child')?.reset();
      this.entityForm.get('childField')?.reset();
      this.showRelativeField = false;
      this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
      this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));      
    }
  }

  async initMethods() {
    this.entityPages = [];
    this.entityList = await this.fetchEntity();
    // Build page-to-entity map directly from the initial entity list
    const pageToEntityMap: { [pageId: string]: string } = {};
    for (const entity of this.entityList) {
      const pageIds = (entity as any).page_ids_list ?? [];
      pageIds.forEach((pageId: string) => {
        pageToEntityMap[pageId] = entity.entity_id;
      });
    }
  this.subscribeToPagesWithEntityMap(pageToEntityMap);

    this.entityForm.get('child')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(async (value: any) => {
      if(value) {
        this.selectedEntityFields = [];
        const relativeEntityDetails = await this.fetchEntity(value, false);
        this.entityFields = this.fetchEntityFields(this.entityDetails.page_widget_details);        
        this.selectedEntityFields = this.fetchEntityFields(relativeEntityDetails.page_widget_details);
        this.showRelativeField = true;
        this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
        this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
      }
    })
  }
 
  toggleEntity(status: boolean, entity: string,eventType:string) {
    this.workflowEntityList = [];
    this.reversedWorkflowList = [];
      this.workflowPanelStatus = false;
    this.sharedService.setSidenavContentlistOption('',false);
    if(eventType !== this.eventTypes.closed){
      this.selectedEntity = status? entity: null;
    }
    this.stageArray.clear();
    this.workFlowForm.reset();
  }

  handleParentFieldTouch() {
    this.parentFieldClicked = true;
    this.buttonClickedParent = false;
  }

  handleChildFieldTouch(){
    this.childFieldClicked = true; 
    this.buttonClickedChild = false;
  }

  fetchEntityFields(entity: any) {
    let returnValue: any[] = [];
    for(let page of entity) {
      returnValue = returnValue.concat(page.widget_details);
    }

    return returnValue;
  }

  async fetchEntity(entity_id: string | null = null, isEntityPageUpdate: boolean = true) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);

    apiConfig.postData = {
      application_id: this.queryParams['id'],
      entity_id: entity_id,
      project_id: null,
      parent_entity_id: null
    }
    const dataStore = entity_id ? 'entityDetails' : 'entityList';
    const returnData: any = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
        next: (response: any) => {
          if (isEntityPageUpdate) {
            if (!entity_id) {
              if (response.data.length > 0) {
                response.data.map((value: Entity, index: number) => { value.open = index == 0 ? false : false; this.isEntityNameEdit[value.entity_id] = false; })
              }
            } else {
              this.getPageDetailsData(response.data);
            }
          }
          resolve(response.data);
        },
        complete: () => {
          this.workflowPanelStatus = false;
        },
        error: (error: any) => {
          console.log(error, 'Error in Fetch entity API');
          if(error?.status == 403) {
            this.toastrService.error('You do not have permission to access this resource.');
          }
          this.isLoadingMappedEntities = false;
          this.workflowPanelStatus = false;
          reject(error);
        } 
      });
    });  
    
    return returnData;
  }

  async fetchPages() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);

    apiConfig.postData = {
      application_id: this.queryParams['id']
    }
    const defaultPages = ['Splash Screen', 'Login', 'Preview'];
    const defaultPageTypes = ['dataListView','PreviewPage'];
    this.pageList = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
        next: (response: PageDetails[]) => {          
              const order = this.sharedService.getApplicationDataEntire()['page_ids_list']
              if(order){
                response = this.pageRearrangeService.rearrangePages(response,order);
              }
              const filteredPages = response.filter((value: PageDetails, index: number) => !defaultPages.includes(value.pageName) && !defaultPageTypes.includes(value?.pageType));          
              resolve(filteredPages);
        },
        complete: () => {},
        error: (error: any) => {
          console.log(error, 'Error in Fetch Pages API');
          if(error?.status == 403) {
            this.toastrService.error('You do not have permission to access this resource.');
          }
          reject(error);
        }
      })
    })
  }

  updateEntity(entity_id: string | null = null) {
    const pages: string[] = [];
    const pageList = entity_id? this.entityPages: this.pagesAdded;
    for(let page of pageList) {
      pages.push(page.pageId);
    }
    const index = this.entityList.findIndex((ele: Entity) => ele.entity_id == entity_id); 
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPDATE_ENTITY']);
    apiConfig.postData = {
      entity_id: entity_id,
      entity_name: entity_id ? this.entityList[index]['entity_name'] : this.entityForm.get('name')?.value,
      child_entity_ids_relation: this.relativeEntityForPostData,
      application_id: this.queryParams['id'],
      page_ids_list: pages,
      removal_page_ids_list: entity_id? this.removedPages: [],
      removal_child_entity_ids_relation: entity_id? this.removedRelativeEntity: []
    }
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        this.toastrService.success(response.message);
      },
      complete: async () => {
        this.resetPageEntities();
        this.isLoadingMappedEntities = true;
        const entityList = await this.fetchEntity();
        await this.refreshPageToEntityMap();
        const entityDetails = await this.fetchEntity(entity_id)
        this.relatedEntityList = entityList?.filter((entity:any)  => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
        this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
        this.isLoadingMappedEntities = false;
        if(this.workflowPanelStatus && this.selectedEntity){
          this.toggleworkFlowEntity(true,this.selectedEntity)
        }
        this.fetchPages();
      },
      error: (error: any) => {
        if(error?.status == 403) {
          this.toastrService.error('You do not have permission to access this resource.');
        }
        console.log(error, 'Error While Submitting Entity');
        this.toastrService.error(error?.error?.message);
      }
    })
  }

  getPageDetailsData(data: any) {
    this.relativeEntity = [];
    this.entityPages = [];
    this.relativeEntityForPostData = {};

    if (!data) return;
    const pageIds = data.page_ids ?? [];
    this.entityPages = this.pageList.filter(page => pageIds.includes(page.pageId));
    for (const entity of data.entity_relation ?? []) {
      const entityDetails = this.entityList.find(ele => ele.entity_id === entity.child_entity_id);
      if (entityDetails) {
        this.relativeEntity.push(entityDetails);
        this.relativeEntityForPostData[entity.child_entity_id] = entity;
      }
    }
    this.updatePageListDropdown();
    this.pageListDropdown = this.pageList.filter(page => !pageIds.includes(page.pageId));
    this.pageListDropdown.sort((a, b) => a.pageName.localeCompare(b.pageName));
    this.pageListDropdown = this.pageListDropdown.filter((page:any) => page?.entityId === "");
    this.relatedEntityList = this.entityList.filter(entity => !this.relativeEntity.some(relEntity => relEntity.entity_id === entity.entity_id));
    this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
  }


  removeRelativeEntityFromEntity(entityId: string, index: number) {
    this.removedRelativeEntity.push(entityId);
    this.relativeEntity.splice(index, 1);
    this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
    this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
  }

  toggleworkFlowEntity(status: boolean, entityId: string) {
    this.workflowPanelStatus = status;
    this.sharedService.setSidenavContentlistOption('',false);
    this.workflowEntityList = [];
    this.reversedWorkflowList = [];
    if(this.workflowPanelStatus && entityId == this.selectedEntity) {
      this.fetchWorkFlows(entityId);
    }
  }

  async toggleWorkFlow(status: boolean, workFlow: WorkFlow, index: number,eventType:string) {
    this.workflowEntityList[index].open = status;
    this.selectedStageId = '';
    if(eventType !== this.eventTypes.closed){
      this.selectedWorkflowIndex = index;
    }
    if(eventType !== this.eventTypes.update){
      this.sharedService.setSidenavContentlistOption('',false);
    }
    this.stageArray.clear();
    if(status) {
      this.stageSpinner = true;
      const workFlowDetails = await this.fetchWorkFlowDetails(workFlow?.worflow_id);
      this.getStageList(workFlowDetails.stages, workFlow?.worflow_id,eventType);
      this.stageSpinner = false;
    }
  }

  getStageList(stageList: any, worflowId: string,eventType:string) {
    this.stageWorkFlowList = [];
    for(const stage of stageList) {
      this.stageWorkFlowList.push({
        stage_id: stage['stage_id'],
        stage_name: stage['stage_name'],
        workflow_id: worflowId
      })
    }
  }

  fetchWorkFlows(entityId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_FETCH']);
    apiConfig.postData = {
      fetch_type: 'entity',
      fetch_id: entityId
    }
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        if(response.result) {
          this.setWorkFlowList(response.response, entityId);
        }
      },
      complete: () => {
      },
      error: (error: any) => {
        if(error?.status == 403) {
          this.toastrService.error('You do not have permission to access this resource.');
        }
        console.log(error, 'Error in Fetching WorkFlows');
        this.toastrService.error('Error in Fetching WorkFlows');
      }
    })
  }

  setWorkFlowList(workFlowList: any[], entityId: string) {
    let count = 0;
    this.workflowEntityList = [];
    for(let workflow of workFlowList) {
      count++;
      const workFlowEntity: WorkFlow = {
        worflow_id: workflow.workflow_id,
        workflow_name: workflow.workflow_name,
        entity_id: entityId,
        open: count == (this.selectedWorkflowIndex+1)
      }
      this.workflowEntityList.push(workFlowEntity);
    }
  }

  fetchWorkFlowDetails(workFlowId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_FETCH']);
    apiConfig.postData = {
      fetch_type: 'workflow',
      fetch_id: workFlowId
    }
    return new Promise<any>((resolve, reject) => {
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
        next: (response: any) => {
          if(response.result) {
            resolve(response.response)
          }
        },
        complete: () => {
        },
        error: (error: any) => {
          console.log(error, 'Error in Fetching WorkFlow Details');
          this.stageSpinner = false
          if(error?.status == 403) {
            this.toastrService.error('You do not have permission to access this resource.');
          }else{
            this.toastrService.error('Error in Fetching Details');
          }
          reject(error);
        }
      })
    }) 
  }

  async editWorkFlow(workFlowId: string) {
    this.editWorkFlowId = workFlowId;
    this.workFlowForm.reset();
    this.stageArray.clear();
    const workFlowDetails = await this.fetchWorkFlowDetails(workFlowId);
    const workFlowName = workFlowDetails.workflow_name;
    this.workFlowForm.get('name')?.setValue(workFlowName);
    const stageDetails = this.setStageDetailsForWorkFlow(workFlowDetails.stages);
    this.openModal(this.workFlowtemplate, true, workFlowDetails.entity_id);
    this.workFlowForm.patchValue({
      name:workFlowName,
      stages: stageDetails
    })
  }

  setStageDetailsForWorkFlow(stageList: any[]) {
    const returnData = [];
    for(const stage of stageList) {
      this.addStage(stage['stage_name']);
      const stageData = {
        name: stage['stage_name']
      }
      returnData.push(stageData);
    }
    return returnData; 
  }

  get stageArray(): FormArray {
    return this.workFlowForm.get("stages") as FormArray;
  }

  addStageGroup(stageName: string = '') {
    return new FormGroup({
      name: new FormControl(stageName, [Validators.required])
    });
  }

  addStage(stageName: string = '') {
    this.stageArray.push(this.addStageGroup(stageName));
  }

  deleteStage(index: number) {
    this.stageArray.removeAt(index)
  }

  saveWorkFlow(entityId: string | null, isEdit: boolean) {    
    if(entityId) {
      const workflow: WorkFlow = {
        entity_id: entityId,
        worflow_id: isEdit ? this.editWorkFlowId: '',
        workflow_name: this.workFlowForm.get('name')?.value,
        open: true
      };
      this.createWorkFlow(workflow, isEdit);
    }    
    this.closeTemplate();
  }

  createWorkflowPayload(workFlow: WorkFlow, isEdit: boolean) {
    if(isEdit) {
      return {
        workflow_id: workFlow.worflow_id,
        workflow_name: workFlow.workflow_name,
        workflow_description: '',
        workflow_config: null,
        stage_config: null
      }
    }else {
      return {
        application_id: this.queryParams['id'],
        workflow_name: workFlow.workflow_name,
        entity_id: workFlow.entity_id,
        workflow_description: '',
        workflow_config: null,
        stage_config: null,
        userId: JSON.parse(localStorage.getItem('userInfo') ?? 'null').userId
      }
    }
  }

  createWorkFlow(workFlow: WorkFlow, isEdit: boolean) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_CREATE_UPDATE']);
    apiConfig.postData = this.createWorkflowPayload(workFlow, isEdit);
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        if(!isEdit) {
          (async () => {
            await this.setStageList(response.response);
            workFlow.worflow_id = response.response.workflow_id
            this.workflowEntityList.push(workFlow);
            this.reversedWorkflowList = [...this.workflowEntityList].reverse();
            this.selectedWorkflowIndex = this.workflowEntityList.length - 1;
          })();
        }
      },
      complete: () => {
        if(isEdit) {
          this.closeTemplate();
          this.fetchWorkFlows(workFlow.entity_id);
        }
      },
      error: (error: any) => {
        console.log(error, 'Error in Creating WorkFlow');
        if(error?.status == 403) {
          this.toastrService.error('You do not have permission to access this resource.');
        }else{
          console.log(error?.error)
          this.toastrService.error(error?.error?.message ?? 'Error in Creating WorkFlow');
        }
      }
    })
  }

  async setStageList(workFlow: any) {
    for(let stageControl of this.stageArray.controls) {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['STAGE_CREATE_UPDATE']);
      apiConfig.postData = {
        workflow_id: workFlow.workflow_id,
        stage_name: stageControl.get('name')?.value,
        stage_description: '',
        stage_type: 'mandatory',
        stage_config: null,
        userId: JSON.parse(localStorage.getItem('userInfo') ?? 'null').userId
      }

      await new Promise((resolve, reject) => {
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
          next: (response: any) => {
            resolve(response.response);
          },
          complete: () => {
          },
          error: (error: any) => {
            console.log(error, 'Error in Creating Stage');
            if(error?.status == 403) {
              this.toastrService.error('You do not have permission to access this resource.');
            }else{
              this.toastrService.error('Error in Creating Stage:', stageControl.get('name')?.value);
            }
            reject(error);
          }
        })
      })
    }
  }

  setStageConfiguration(stageId: string, workflowId: string, entityId: string, isEdit: boolean,stage:any) {
    this.selectedStageId = stageId;
    this.sharedService.onMobileScreenDropUpdateData({stage: stageId, isEdit: isEdit, workflow: workflowId, entity: entityId,stageName:stage.stage_name})
    this.sharedService.setSidenavContentlistOption('stage',true);
  }

  async onEntityClicked(entity: Entity, index: number) {
    this.matPanelStatus = false;
    this.relatedPanelStatus = false;
    this.workflowPanelStatus = false;

    this.relativeEntity = [];
    this.selectedEntityName = entity.entity_name;
    this.entityPages = [];
    if (this.entityList[index].open) this.entityList[index].open = false;
    else this.entityList[index].open = true;
    this.entityList.forEach((item, i) => {
      if (i !== index) {
        item.open = i === index;
      }
    });
    this.entityDetails = await this.fetchEntity(entity.entity_id);
    this.entityForm.get('child')?.reset();
    this.entityForm.get('childField')?.reset();
    this.updatePageListDropdown();
  }

  deleteWorkFlow(workFlowId: string, entityId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_DELETE']);

    apiConfig.postData = {
      workflow_id: workFlowId
    }

    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        this.toastrService.success(response.message);
      },
      complete: () => {
        this.closeTemplate();
        this.fetchWorkFlows(entityId);
      },
      error: (error: any) => {
        console.log(error, 'Error in Deletion of Entity');
        if(error?.status == 403) {
          this.toastrService.error('You do not have permission to access this resource.');
        }else{
          this.toastrService.error('Error in Deletion of Entity');
        }
      }
    })
  }

  deleteStageFromWorkFlow(stageId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['STAGE_DELETE']);

    apiConfig.postData = {
      stage_id: stageId
    }

    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        this.toastrService.success(response.message);
      },
      complete: () => {
        this.closeTemplate();
        const index = this.stageWorkFlowList.findIndex((stage: Stage) => stage.stage_id === stageId);
        this.stageWorkFlowList.splice(index, 1);
      },
      error: (error: any) => {
        console.log(error, 'Error in Deletion of Entity');
        if(error?.status == 403) {
          this.toastrService.error('You do not have permission to access this resource.');
        }else{
          this.toastrService.error('Error in Deletion of Entity');
        }
      }
    })
  }

  async deleteEntityPopup(template: TemplateRef<any>, entity: any, index: number) {
    this.pageNamesList=[];
    this.deleteEntityid = entity?.entity_id;
    this.entityName = entity.entity_name;
    await this.onEntityClicked(entity, index)
    this.pageNamesList.push(...this.entityPages.map(pageDetail => pageDetail.pageName));
    const dialogRef = this.dialog.open(template, {
      disableClose: true,
      restoreFocus: false
    });
  }
  updatePageListDropdown() {
    this.pageListDropdown = this.pageList
      .filter((page) => !this.entityPages.some((entityPage) => entityPage.pageId === page.pageId)) // Exclude current entity's pages
      .filter((page: PageDetails) => !page.entityId); // Exclude pages assigned to any entity (entityId is not empty or undefined)
    this.pageListDropdown.sort((a, b) => a.pageName.localeCompare(b.pageName));
  }

  async deleteEntity(entityId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_ENTITY']);

    apiConfig.postData = {
      application_id: this.queryParams['id'],
      entity_id: entityId
    }
    const entityDetails = await this.fetchEntity(entityId);
    const deletedPageIds = entityDetails.page_ids ?? [];
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$),take(1)).subscribe({
      next: (response: any) => {
        this.toastrService.success(response.result);
      },
      complete: async () => {
        this.closeTemplate();
        this.pageList = this.pageList.map(page => {
          if (deletedPageIds.includes(page.pageId)) {
            return { ...page, entityId: '' }; // Unassign page
          }
          return page;
        });
        // Sync with pages1$ in SharedService
        const currentPages = this.sharedService.getPages();
        const updatedPages = currentPages.map(page => {
          if (deletedPageIds.includes(page.pageId)) {
            return { ...page, entity_id: '' }; // Unassign entity_id in PAGEI
          }
          return page;
        });
        this.sharedService.updatePages(updatedPages);
        this.entityList = this.entityList.filter(entity => entity.entity_id !== entityId);
        if (this.entityDetails?.entity_id === entityId) {
          this.entityPages = [];
        }
        await this.refreshPageToEntityMap();
        // Update dropdown to reflect changes
        this.updatePageListDropdown();
      },
      error: (error: any) => {
        console.log(error, 'Error in Deletion of Entity');
        if(error?.status == 403) {
          this.toastrService.error('You do not have permission to access this resource.');
        }else{
          this.toastrService.error('Error in Deletion of Entity');
        }
      }
    })
  }
   
  resetPageEntities(){
    this.entityForm.reset();
    this.workFlowForm.reset();
    this.pagesAdded = [];
    this.relativeEntityAdded = [];
    this.isAddAttributes = false;
    this.removedRelativeEntity = [];
    this.removedPages = [];
    this.isAddRelations = true;
    this.isAddEntity = false;
    this.showRelativeField = false;
    this.entityPages = [];
    this.workflowEntityList = [];
    this.reversedWorkflowList = [];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
